<template>
  <UiModal :open="appUpdateRequired" aria-label="App update required" panel-class="max-w-md">
    <UiModalBody padding-top padding-bottom>
      <!-- Icon -->
      <div
        class="mx-auto flex h-12 w-12 items-center justify-center rounded-full mb-4 bg-blue-100 dark:bg-blue-900/30"
      >
        <ArrowPathIcon class="h-6 w-6 text-blue-600 dark:text-blue-400" />
      </div>

      <!-- Title -->
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white text-center">App Updated</h3>

      <!-- Message -->
      <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center">
        A new version of the app is available. Please refresh the page.
      </p>

      <!-- Button -->
      <div class="mt-6">
        <button
          class="w-full px-4 py-2.5 text-sm font-medium rounded-lg bg-brand-600 hover:bg-brand-700 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
          @click="refresh"
        >
          Refresh Page
        </button>
      </div>
    </UiModalBody>
  </UiModal>
</template>

<script setup lang="ts">
import { UiModal, UiModalBody } from "@handled/ui/Modal";
import { ArrowPathIcon } from "@heroicons/vue/24/outline";

import { appUpdateRequired } from "@/composables/useAppUpdate";

function refresh() {
  window.location.reload();
}
</script>
